/**
 * Общие наборы классов маркетинговых экранов франчайзи.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫМ МОДУЛЕМ. До этого те же четыре константы лежали
 * одинаковыми строками в четырёх файлах (`PartnerMarketingPage`,
 * `PartnerMarketingPlanningPage`, `PartnerMarketingDailySummaryPage`,
 * `PartnerMarketingFactorAnalysis`) — правка оформления в одном месте
 * молча расходилась с тремя остальными.
 *
 * ⚠️ ЗДЕСЬ ТОЛЬКО РОЛИ И ОБЩАЯ ПАЛИТРА. Экраны были нарисованы своей
 * тёплой схемой из 42 произвольных токенов `mkt-*`; она снята, потому что
 * это был дрейф, а не отдельный бренд: 42 токена свелись к 13 значениям,
 * которыми приложение уже пользуется. Новый цвет сюда добавлять только
 * ролью (`bg-card`, `text-muted-foreground`) либо ступенью `amber` —
 * единственного акцентного семейства приложения (770 использований).
 * `stone` не использовать: в приложении его нет нигде.
 */

/**
 * Карточка раздела. Кладётся в `className` компонента `<Card>`, который
 * сам даёт `bg-card rounded-card shadow-card` — поэтому здесь только
 * рамка: дублировать тень значит рисовать её дважды.
 */
export const SURFACE_CARD_CLASS = 'border border-border'

/** Вложенная панель внутри карточки — та же поверхность, но своей рамкой. */
export const SUBTLE_PANEL_CLASS = 'rounded-2xl border border-border bg-card'

/** Чип активного фильтра. Акцент — янтарь, как во всём приложении. */
export const FILTER_CHIP_CLASS =
  'rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700'

/** Поле ввода. */
export const INPUT_CLASS =
  'w-full rounded-lg border border-border bg-card px-3 py-2 text-sm text-foreground'
